import React from "react";
import InfoDrawer from "../../../../ui/InfoDrawer";
import {getAnswers} from "../../store/actions";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import InfoField from "../../../../ui/InfoDrawer/components/InfoField";
import DeviderLine from "../../../../ui/InfoDrawer/components/DeviderLine";

const AnswersDrawer = ({open, sessionGuid, getAnswers, answers}) => {

  React.useEffect(() => {
    if (sessionGuid !== "") {
      getAnswers(sessionGuid);
    }
  }, [sessionGuid]);

  return <InfoDrawer open={open}>
      {answers && answers.map(a =><>
        <InfoField name={a.questionText} display={"block"} value={a.answer}/>
        <DeviderLine/></>
      )}
    </InfoDrawer>
};

const mapStateToProps = state => ({
  answers: state.enjoyQuiz.answers
});

const mapDispatchToProps = dispatch => ({
  getAnswers: id => dispatch(getAnswers(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AnswersDrawer));
